import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-wait-container',
    templateUrl: './wait-container.component.html',
    styleUrls: ['./wait-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WaitContainerComponent {

  @Input()
  loading: boolean = null;

}
